"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const meStateQuery = (0, graphql_tag_1.default)`
  query me {
    me {
      state {
        hoa {
          id
          name
          housesType
          structureType
          code
          proportionOwnershipSymbol
          allowContractDownload
          address
          buildingCount
          cityFiasId
          regionFiasId
          lat
          lng
        }
        user {
          id
          firstName
          active
          lastName
          middleName
          allowsPrivateNotifications
          avatarUrl
          avatarColor
          avatarBorderColor
          avatarText
          displayRole
          hasTelegram
          avatarDisplayName
          showMyAvatar
          nickname
          personType
          account {
            id
            email {
              id
              type
              value
              isVerified
              verificationSendTime
            }
            phone {
              id
              type
              value
              isVerified
              verificationSendTime
            }
          }
          role
          accessLevel
          isRegistered
          juristicPersonName
          juristicPersonLegalForm
          hasPrivateProfile
          membership
        }
        paymentProvider
        apiKey
        isMultiAccount
        appInstalled
        language
      }
      settings {
        allowsCommonNotifications
        allowsPrivateNotifications
        allowTelegramMessage
      }
      socialAccounts {
        boundNetworks {
          socialType
          avatar
          fullName
        }
      }
      lockingPopup {
        fields
        hasLocking
      }
    }
  }
`;
exports.default = meStateQuery;